import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dcbef122"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer mt-auto py-2 bg-light text-center" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Главная")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("О сервисе")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Контакты")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" © ОАО \"НЭСК\" Ош ПЭС"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone" }),
  /*#__PURE__*/_createTextVNode(" "),
  /*#__PURE__*/_createElementVNode("a", { href: "tel:+996322282515" }, "+996 3222 82515"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.instagram.com/oshpes.kg/",
    class: "btn azm-social azm-size-32 azm-circle azm-instagram",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fab fa-instagram" })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "btn btn-link"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/about",
          class: "btn btn-link"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/contact",
          class: "btn btn-link"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _hoisted_6
    ])
  ]))
}